import type { ArdoqId } from '@ardoq/api-types';
import type { FieldValueScopeSource } from '@ardoq/data-model';
import type { ReferenceFilterContext } from '@ardoq/filter-helpers';
import { componentInterface } from '../componentInterface';

/**
 * Id-based wrapper around `componentInterface.isIncludedInContextByFilter`.
 * Missing components are treated as included — matches the pre-migration
 * behavior of the front-end implementation, which defaulted to `true` when
 * the component was not in the store.
 */
export const isComponentIdIncludedInContextByFilter = (
  componentId: ArdoqId,
  ctx?: ReferenceFilterContext,
  scopeSource?: FieldValueScopeSource | null
): boolean => {
  const component = componentInterface.get(componentId);
  return component
    ? componentInterface.isIncludedInContextByFilter(
        component,
        ctx,
        scopeSource
      )
    : true;
};
